/* eslint-disable ember/no-new-mixins */
import { service } from "@ember/service";
import Mixin from "@ember/object/mixin";
import RESTAdapter from "@ember-data/adapter/rest";
import { waitForPromise } from "@ember/test-waiters";
import config from "../config/environment";
import { isApiDirectlyUri, isIoUrl, ioApiBaseUri } from "../services/http";

export const projectChildMixin = Mixin.create({
  uriSuffix: null,

  buildURL(type, id, snapshot) {
    let baseUri = this.baseUriProject(snapshot);
    let uriSuffix = this.uriSuffix;
    let url = `${baseUri}/${uriSuffix}`;

    if (id) {
      url += `/${id}`;
    }

    return url;
  },
});

export const adapterConfig = Mixin.create({
  session: service(),

  namespace: "io.php",

  get headers() {
    let headers = {
      "Content-Type": "application/json",
    };
    if (this.session.basicToken) {
      headers.Authorization = `Basic ${this.session.basicToken}`;
    }
    return headers;
  },

  get host() {
    if (config.ioApiBaseUri !== null) {
      return config.ioApiBaseUri;
    }

    return "";
  },
});

export default class ApplicationAdapter extends RESTAdapter.extend(adapterConfig) {
  coalesceFindRequests = true;

  // Direct `adapter.ajax()` calls skip the RequestManager, whose test waiter is what makes settled() wait for requests.
  ajax() {
    return waitForPromise(super.ajax(...arguments));
  }

  ajaxOptions() {
    let options = super.ajaxOptions(...arguments);
    options.ifModified = true;

    let url = new URL(options.url, document.location.origin);
    let context = url.searchParams.get("context");
    if (context && isApiDirectlyUri(options.url)) {
      if (this.session.basicToken) {
        options.headers.Authorization = `Basic ${this.session.tokenFor(context)}`;
      }
      url.searchParams.delete("context");
      options.url = url.toString();
    }

    if (isApiDirectlyUri(options.url) && ["PUT", "DELETE"].includes(options.method)) {
      options.method = "POST";
    }

    return options;
  }

  get apiBaseUri() {
    return config.apiBaseUri;
  }

  baseUri() {
    let uri = [];

    uri.push(this.host);

    let namespace = this.namespace;
    uri.push(namespace);

    return uri.join("/");
  }

  baseUriProject(snapshot) {
    if (snapshot) {
      let baseUri = this.baseUri();
      let project;

      project = snapshot.belongsTo("project");

      if (typeof project !== "undefined") {
        return `${baseUri}/projects/${project.id}`;
      }

      return baseUri;
    }
  }

  findHasMany(store, snapshot, url /* , relationship */) {
    url = this.urlPrefix(url, this.buildURL(snapshot.modelName, snapshot.id, snapshot, "findHasMany"));
    return this.ajax(url, "GET");
  }

  handleResponse(status, headers, payload, requestData) {
    if (status === 422 && isApiDirectlyUri(requestData.url)) {
      let requestUrl = requestData.url.replace(new URL(requestData.url).origin, "");
      payload.errors = [
        {
          status: payload.response.status.code,
          title: payload.response.status.text,
          detail: payload.response.status.text,
          source: { pointer: "/data/attributes" + requestUrl },
        },
      ];
    }

    return super.handleResponse(status, headers, payload, requestData);
  }

  normalizeErrorResponse(status, headers, payload) {
    return super.normalizeErrorResponse(
      status,
      headers,
      payload?.error?.message ?? payload?.response?.status?.text ?? payload,
    );
  }

  buildURL(type, id, snapshot) {
    let uri = super.buildURL(...arguments);
    let apiBaseUri = isIoUrl(uri) ? ioApiBaseUri : config.apiBaseUri;
    let url = new URL(uri, apiBaseUri);

    let context = snapshot?.adapterOptions?.context;
    if (context) {
      url.searchParams.set("context", context);
    }
    return url.toString();
  }
}
